import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const resolverRef = useRef(null);
  const [confirmState, setConfirmState] = useState({
    open: false,
    title: '',
    message: '',
    details: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    variation: 'info',
    badge: 'Confirmación',
    icon: 'help',
  });

  const closeDialog = useCallback((result) => {
    setConfirmState((prev) => ({ ...prev, open: false }));
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  }, []);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setConfirmState({
        open: true,
        title: options?.title || '¿Deseas continuar?',
        message: options?.message || 'Confirma esta acción para continuar.',
        details: options?.details || '',
        confirmText: options?.confirmText || 'Confirmar',
        cancelText: options?.cancelText || 'Cancelar',
        variation: options?.variation || 'info',
        badge: options?.badge || 'Confirmación',
        icon: options?.icon || 'help',
      });
    });
  }, []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      <ConfirmDialog
        confirmState={confirmState}
        onConfirm={() => closeDialog(true)}
        onCancel={() => closeDialog(false)}
      />
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm debe ser usado dentro de ConfirmProvider');
  }
  return context;
}

export default ConfirmContext;
